import { render, staticRenderFns } from "./AssociationsListModal.vue?vue&type=template&id=2dae59f2&scoped=true"
import script from "./AssociationsListModal.vue?vue&type=script&lang=js"
export * from "./AssociationsListModal.vue?vue&type=script&lang=js"
import style0 from "./AssociationsListModal.vue?vue&type=style&index=0&id=2dae59f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dae59f2",
  null
  
)

export default component.exports